import ChartIcon from './chart.svg';
import ReaderIcon from './reader.svg';

export { ChartIcon, ReaderIcon };
